import { render } from "./ItemSimilar.vue?vue&type=template&id=ec51cd14&scoped=true"
import script from "./ItemSimilar.vue?vue&type=script&lang=js"
export * from "./ItemSimilar.vue?vue&type=script&lang=js"

import "./ItemSimilar.vue?vue&type=style&index=0&id=ec51cd14&scoped=true&lang=css"

import exportComponent from "C:\\Users\\musta\\Área de Trabalho\\Projetos\\catalogo\\catalogo-pedidos\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec51cd14"]])

export default __exports__